import type { ReactNode } from 'react';
import { StyleSheet, View } from 'react-native';

import { spacing } from '@/src/theme/spacing';

export {
  commentRowFrameVariant,
  type CommentRowFrameVariant,
} from './comment-row-frame-utils';

export function CommentRowFrame({
  children,
  footer,
  headerActions,
  identity,
  isReply = false,
  status,
}: {
  children?: ReactNode;
  footer?: ReactNode;
  headerActions?: ReactNode;
  identity: ReactNode;
  isReply?: boolean;
  status?: ReactNode;
}) {
  return (
    <View style={[styles.row, isReply ? styles.replyRow : null]}>
      {isReply ? (
        <View
          accessibilityElementsHidden
          importantForAccessibility="no"
          pointerEvents="none"
          style={styles.replyRail}
        />
      ) : null}
      <View style={[styles.surface, isReply ? styles.replySurface : null]}>
        <View style={styles.header}>
          <View style={styles.identityFrame}>{identity}</View>
          {headerActions ? (
            <View style={styles.headerActions}>{headerActions}</View>
          ) : null}
        </View>
        {children ? <View style={styles.content}>{children}</View> : null}
        {footer ? <View style={styles.footer}>{footer}</View> : null}
        {status ? <View style={styles.status}>{status}</View> : null}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  content: {
    gap: spacing.sm,
    minWidth: 0,
  },
  footer: {
    borderTopColor: '#ede7f6',
    borderTopWidth: 1,
    paddingTop: spacing.xs,
  },
  header: {
    alignItems: 'flex-start',
    flexDirection: 'row',
    gap: spacing.sm,
    justifyContent: 'space-between',
    minWidth: 0,
  },
  headerActions: {
    alignItems: 'center',
    flexDirection: 'row',
    flexShrink: 0,
    gap: spacing.xs,
  },
  identityFrame: {
    flex: 1,
    minWidth: 0,
  },
  replyRail: {
    backgroundColor: '#e2d8f3',
    borderRadius: 999,
    bottom: spacing.xs,
    left: 0,
    position: 'absolute',
    top: spacing.xs,
    width: 2,
  },
  replyRow: {
    marginLeft: spacing.lg,
    paddingLeft: spacing.sm,
  },
  replySurface: {
    backgroundColor: '#fffafd',
    paddingHorizontal: spacing.sm,
    paddingVertical: spacing.xs,
  },
  row: {
    minWidth: 0,
    position: 'relative',
  },
  status: {
    alignSelf: 'flex-start',
  },
  surface: {
    backgroundColor: '#fbf9ff',
    borderColor: '#e7e0f3',
    borderRadius: 8,
    borderWidth: 1,
    gap: spacing.sm,
    paddingHorizontal: spacing.md,
    paddingVertical: spacing.sm,
  },
});
